import { Grid, Skeleton, Stack, Typography } from "@mui/material";
import { BlinkedBox } from "components/common/animations/blink-dot/BlinkDot.component";
import { motion } from "framer-motion";
import { round, uniqueId } from "lodash";
import { YourOrderWrapper } from "pages/your-orders/your-orders.style";
import React, { useEffect } from "react";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { useNavigate, useParams } from "react-router-dom";
import { useAppApi } from "store/api-context";
import {
  getColorWithOrderStatus,
  scrollToTop,
} from "utils/common/common.utils";
import { ROUTES } from "utils/constants/route.constants";
import { getProductImageUri } from "utils/module-helper";

const SeeAllCardItems = ({ order, onClickSeeAllItems, onClickBuyAgain }) => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const {
    isOrderPlacing,
    fetchYourOrdersById,
    isLoading,
    state: { orderItems },
  } = useAppApi();

  const handleBackClick = () => {
    navigate(ROUTES.YOUR_ORDERS);
  };

  useEffect(() => {
    fetchYourOrdersById(orderId);
    scrollToTop();
  }, [orderId]);

  console.log("orderItems", orderItems);
  return (
    <YourOrderWrapper>
      <Grid
        container
        xs={12}
        sx={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid
          item
          xs={8}
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Stack>
            <Typography
              sx={{
                marginTop: "2rem",
                marginBottom: "2rem",
                padding: {
                  xs: "0 2rem 0 2rem",
                  md: "0 4rem",
                },
                fontFamily: '"Jacques Francois Shadow", cursive',
                fontSize: {
                  xs: "1.5rem",
                  md: "2rem",
                },
              }}
            >
              Your Orders
            </Typography>
          </Stack>
        </Grid>
        <Grid
          item
          xs={4}
          sx={{
            alignItems: "flex-end",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Stack
            flexDirection="row"
            alignItems="center"
            gap="10px"
            onClick={handleBackClick}
            sx={{
              padding: {
                xs: "0 2rem",
                md: "0 4rem",
              },
              cursor: "pointer",
            }}
          >
            <AiOutlineArrowLeft /> <Typography>Back</Typography>
          </Stack>
        </Grid>
      </Grid>

      <Grid container spacing={4}>
        <Grid item xs={12}>
          {isLoading
            ? [1, 2, 3, 4, 5, 6].map((item) => (
                <Stack gap={4}>
                  <Skeleton
                    variant="rectangular"
                    width={{
                      xs: "50%",
                      md: 210,
                    }}
                    height={100}
                  />
                </Stack>
              ))
            : orderItems?.items?.map((item) => {
                const data = [
                  {
                    name: "Style no",
                    value: item?.product?.styleNo,
                  },
                  {
                    name: "Quantity",
                    value: item?.quantity,
                  },
                  {
                    name: "Sku",
                    value: item?.product?.sku,
                  },
                  {
                    name: "Color",
                    value: item?.color,
                  },
                  {
                    name: "Melting",
                    value: item?.melting,
                  },
                  {
                    name: "Screw",
                    value: item?.screw,
                  },
                  {
                    name: "Size",
                    value: item?.size,
                  },
                  {
                    name: "N:weight",
                    value: round(item?.product?.netWeight, 3),
                  },
                  {
                    name: "G:weight",
                    value: round(item?.product?.grossWeight, 3),
                  },
                  {
                    name: "Remark",
                    value: item?.remarks,
                  },
                ];

                return (
                  <motion.div
                    key={uniqueId()}
                    style={{
                      backgroundColor: "#FFFCF9",
                      padding: "1rem 1.4rem",
                    }}
                    data-testid="order-card-item"
                  >
                    <Grid container xs={12} spacing={2}>
                      <Grid item xs={5}>
                        <motion.div>
                          <img
                            src={getProductImageUri({
                              styleNo: item?.product?.styleNo,
                              imageFlag: item?.product?.imageFlag,
                              client: item?.product?.client,
                              division: item?.product?.division,
                            })}
                            width="100%"
                            alt={item?.product?.styleNo}
                            style={{
                              objectFit: "contain",
                              borderRadius: "10px",
                              height: "156px",
                              "@media (max-width:768px)": {
                                height: "100px",
                              },
                            }}
                          />
                        </motion.div>
                      </Grid>
                      <Grid item xs={7} container>
                        <Grid item xs={12} spacing={2}>
                          <Stack direction="row" justifyContent="space-between">
                            {" "}
                            <Typography
                              style={{
                                fontSize: "12px",
                                fontFamily: "Outfit",
                                fontWeight: 600,
                                lineHeight: "16.8px",
                                textTransform: "uppercase",
                                color: "#A54201",
                              }}
                            >
                              {item?.product?.category?.name}
                            </Typography>
                            <Typography
                              color="tertiary"
                              sx={{
                                fontSize: "12px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  gap: 2,
                                }}
                              >
                                <BlinkedBox
                                  size={7}
                                  color={getColorWithOrderStatus(
                                    item?.orderStatus
                                  )}
                                />{" "}
                                {item?.orderStatus || "--"}
                              </div>
                            </Typography>
                          </Stack>
                          <motion.div
                            style={{
                              marginLeft: "0.3rem",
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "10px",
                            }}
                          >
                            <Grid container xs={12} spacing={1.3}>
                              {data?.map((renderItem) => (
                                <Grid item xs={6} key={uniqueId()}>
                                  <Typography
                                    sx={{
                                      fontSize: "12px",
                                      display: "flex",
                                    }}
                                  >
                                    {renderItem.name}:{" "}
                                    {renderItem?.value || "--"}
                                  </Typography>
                                </Grid>
                              ))}
                            </Grid>
                          </motion.div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </motion.div>
                );
              })}
        </Grid>
      </Grid>
    </YourOrderWrapper>
  );
};

export default SeeAllCardItems;
